import React from "react";
import { Grid, Box, Typography } from "@mui/material";
import { fonts, themes } from "../../../common/themes/themes";
import "./Leaves.css";
import LeaveAppliedController from "../../../domain/myProfile/leaves/LeaveApplied/LeaveAppliedController";
import LeaveEligibilityController from "../../../domain/myProfile/leaves/LeaveEncashment/LeaveEligibilityController";
import LeaveHistoryController from "../../../domain/myProfile/leaves/LeaveHistory/LeaveHistoryController";
import LeaveCalendarController from "../../../domain/myProfile/leaves/LeaveCalendar/LeaveCalendarController";
import { useAppSelector } from "../../../infra/hooks";
import { useTranslation } from "react-i18next";

const LeavesPresenter = () => {
  const isHRView = useAppSelector((state) => state.isHRViewSlice.HRView);
  const { t, i18n } = useTranslation();
  
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const trans: any = t;

  return (
    <Grid
      container
      style={{
        display: "flex",
        flexWrap: "nowrap",
        marginTop: isHRView ? "" : "4em",
        width: "100vw",
        paddingRight: "8em",
      }}
    >
      <Grid
        item
        xs={11}
        sm={11}
        md={11}
        lg={11}
        sx={{
          backgroundColor: "#F5F5FA",
          width: "100%",
          padding: "1.75em",
          marginLeft:
            isHRView && i18n.language == "en"
              ? "11em"
              : !isHRView && i18n.language == "en"
              ? "14em"
              : "",
          marginRight: i18n.language == "ar" ? "15em" : "",
        }}
      >
        <Grid
          container
          style={{
            paddingLeft: isHRView ? "2em" : "",
          }}
        >
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            sx={{
              width: "100%",
              height: "80px",
            }}
          >
            <Grid
              container
              style={{
                width: "auto",
                background: "#FFFFFF 0% 0% no-repeat padding-box",
                borderRadius: "10px",
                opacity: "1",
                display: "flex",
                flexDirection: "row",
                paddingTop: "1em",
                paddingBottom: "1em",
                paddingLeft: "1em",
                paddingRight: "1em",
              }}
            >
              <Grid item xs={9}>
                <Typography
                  style={{
                    fontFamily: fonts.fontFamily,
                    fontSize: fonts.header,
                    color: themes.blackDefault,
                    fontWeight: "bold",
                  }}
                >
                  {trans("Leaves")}
                </Typography>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Grid
              container
              spacing={3}
              style={{
                width: "auto",
              }}
            >
              <Grid item xs={4} sm={4} md={4} lg={4}>
                <LeaveAppliedController />
                <Box style={{ marginTop: "1.75em" }} />
                <LeaveCalendarController />
              </Grid>
              <Grid item xs={4} sm={4} md={4} lg={4}>
                <LeaveEligibilityController />
              </Grid>
              <Grid item xs={4} sm={4} md={4} lg={4}>
                <LeaveHistoryController />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default LeavesPresenter;
